module.exports = __webpack_public_path__ + "img/rencai.c03c7f9f.jpg";